import React from 'react';
import PropTypes from 'prop-types';
import { Route, Link, withRouter } from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import HelpIcon from '@material-ui/icons/Help'
import AwesomeDebouncePromise from 'awesome-debounce-promise'
import LectureTextEdit from './text_edit'
import LectureQuizEdit from './quiz_edit'
import './lecture.css'
import { Container, Divider, FormControl, FormLabel, TextField } from '@material-ui/core';
import { FormGroup } from '@material-ui/core';
import { FormControlLabel } from '@material-ui/core';
import { Checkbox } from '@material-ui/core';
import { Help } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';

const isEqual = require("react-fast-compare")

class LectureEdit extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      quizvisible : false,
      qlist : [],
      userliste : [],
      lecture : {text:{},test:{},external:false,qualifications:[],ausgeblendet:false},
    }
  }

  componentDidMount (){
    const {params} = this.props.match ? this.props.match : false
    if (params && 'id' in params) this.setState({id : params.id})
    let s = this.props.socket
    s.emit('get userlist',data => this.setState({userliste:data}))
    s.on(params.id+' lecture full', data => {
      this.setState({lecture : {qualifications:[],writepermission:[],ownresults:false,certificate:false,...data}})
    })
    s.on(params.id+' lecture test', data => {
      if (data.username !== this.props.userdata.username){
          this.setState({lecture :{...this.state.lecture,test: data.test}})
        }
    })
    s.on(params.id+' lecture text', data => {
      if (data.username !== this.props.userdata.username && !isEqual(this.state.lecture.text.cells,data.text.cells)){
        this.setState({lecture :{...this.state.lecture,text :  data.text, external:true}})
      } else if (this.state.lecture.editor === 'video') {
        this.setState({lecture : {...this.state.lecture,text :  data.text, external:true}})
      }
    })
    s.on(params.id+' lecture qualifications', data => 
      this.setState({lecture:{...this.state.lecture,qualifications:data}})
    )
    s.on(params.id+' lecture parameter', data => 
      this.setState({lecture:{...this.state.lecture,...data}})
    )    
    s.emit('get distinct qualifications',data => {
      this.setState({qlist:data})
  })
    s.emit('get lecture full',{id : params.id})
  }

  handleTextChange = (t) => {
    let s = this.props.socket
    let prevLecture = this.state.lecture
    if (!prevLecture.text) {
      s.emit('mod lecturetext',{id:this.state.id,text:t})
    } else if (!isEqual(t.cells,prevLecture.text.cells)) {
      !prevLecture.external && s.emit('mod lecturetext',{id:this.state.id,text:t})
      this.setState({lecture : {...prevLecture,text : t,external:false}})
    }
  }

 

  toggleQuiz = () => {
    let tmp = this.state.quizvisible
    this.setState({quizvisible : !tmp})
  }


    modQuiz = (newval) => {
      let quiz = this.state.lecture
      let s = this.props.socket
      this.setState({lecture : {...quiz,test:newval}})
      s.emit('mod lecturetest',{id:this.state.id,test:newval})
    }

    handleQualiChange = (val) => {
      let quali = this.state.lecture.qualifications
      let s = this.props.socket
      if (quali.indexOf(val) !== -1 ) {
        quali = quali.filter(v => v !== val)
      } else {quali = [...quali,val]}
      s.emit('mod lecture qualifications',{id:this.state.id,qualifications:quali})
    }

    handleParameterChange = (p,v) => {
      let s = this.props.socket
      s.emit('mod lecture parameter',{id:this.state.id,parameter:p,value:v})
    }


  render () {
    const {lecture, id, quizvisible,userliste} = this.state
    return (
      <div>
        <Typography variant="h3" gutterBottom className='headline'>{lecture.name}</Typography>
        <Divider/>
      <Container>
      <Paper style={{marginBottom:'10px', padding:'10px', backgroundColor: lecture.ausgeblendet ? '#ffebee' : 'inherit'}}>
        <FormControlLabel
          control={<Checkbox checked={lecture.ausgeblendet || false} onChange={e => this.handleParameterChange('ausgeblendet',!lecture.ausgeblendet)} color="secondary" name={'ausgeblendet'}/>}
          label={<Typography variant="subtitle1" style={{fontWeight:'bold'}}>Ausgeblendet (nicht sichtbar für Mitarbeiter)</Typography>}
        />
      </Paper>
      <Paper style={{marginBottom:'10px'}}>
      <Typography variant="h6">Freigabe</Typography>
     <FormControl component="fieldset">
       <FormLabel>Freigegeben für:</FormLabel>
       <FormGroup row>
         {this.state.qlist && this.state.qlist.map((q,i) => 
        <FormControlLabel key={'qua'+i} control={<Checkbox value={q} checked={lecture.qualifications.indexOf(q) !== -1} onChange={e => this.handleQualiChange(e.target.value)} color="primary" name={'qlist'}/>} label={q} />
        )}
        </FormGroup>
      </FormControl>
      </Paper>
      <Paper  style={{marginBottom:'10px'}}>
        <Typography variant="h6">Einstellungen</Typography>
        <FormControlLabel  control={<Checkbox value={!lecture?.certificate} checked={lecture.certificate || false} onChange={e => this.handleParameterChange('certificate',!lecture.certificate)} color="primary" name={'certificate'}/>} label={'selbstständige Bescheinigungserstellung'} />
        <FormControlLabel  control={<Checkbox value={!lecture?.ownresults} checked={lecture.ownresults || false} onChange={e => this.handleParameterChange('ownresults',!lecture.ownresults)} color="primary" name={'ownresults'}/>} label={'Einsicht in eigene Testergebnisse'} />
      <TextField value={lecture.duration || 2} onChange={e => this.handleParameterChange('duration',e.target.value)} type="numeric" label="Zeitanrechnung für Fortbildungen"/>
      <FormControl component="fieldset">
       <FormLabel>Mitarbeiter mit Bearbeitungsrechten</FormLabel>
       {userliste && lecture.writepermission && 
          <Autocomplete multiple fullWidth options={userliste} defaultValue={lecture.writepermission}  getOptionLabel={o => o} autoSelect autoHighlight
          style={{minWidth:'150px'}}
          onChange={(e,n) => this.handleParameterChange('writepermission',n)}
          renderInput={(params) => (
            <TextField
              {...params}
              
              variant="standard"
              label="Autoren"
            />
          )}
          />
        }        

      </FormControl>  
      </Paper>
      </Container>
     <Divider/>
      <div className='container'>
      <Paper className='textcontainer'>
      {'name' in lecture &&  <LectureTextEdit id={id} editorplugin={lecture.editor || 'ory'} text={lecture.text} 
      external={lecture.external} userdata={this.props.userdata} onTextChange={this.handleTextChange} socket={this.props.socket}/>}
      </Paper>
      <Paper className={'quizcontainer '+(quizvisible && 'quizvisible')}>
      {'name' in lecture && <LectureQuizEdit id={id} {...lecture.test} modQuiz={newval => this.modQuiz(newval)} /> }
      </Paper>
      {/* <Button variant="fab" color="secondary" className={lecture.editor == 'tinymce' ? 'quizbutton bottom' : 'quizbutton'}  onClick={this.toggleQuiz}> */}
        <Help color="secondary" fontSize='large' className={lecture.editor == 'tinymce' ? 'quizbutton bottom' : 'quizbutton'}  onClick={this.toggleQuiz}/>
        {/* </Button> */}
      </div>
      </div>
    )
  }


}

export default withRouter(LectureEdit)
